<template></template>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;
          }
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '200',
          max: '768',
          labelDesc: 'max-width-tablet',
          callback: function() {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';

          },
        },
        alignMenu: {
          name: 'alignMenu',
          defaultValue: 'left',
          labelDesc: 'align-menu',
          callback: function() {
            vm.resources.alignMenu.defaultValue = this.value;
            vm.element.internal_config.align = this.value;
          },
        },
        menuMobileEffect: {
          name: 'menuMobileEffect',
          defaultValue: '',
          labelDesc: 'menu-mobile-effect',
          options: [
            {name: vm.$t('ct-option-menu-mobile-effect-none'), value: '', selected: 'selected', disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-blind'), value: 'blind', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-bounce'), value: 'bounce', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-clip'), value: 'clip', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-drop'), value: 'drop', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-fade'), value: 'fade', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-fold'), value: 'fold', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-puff'), value: 'puff', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-pulsate'), value: 'pulsate', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-scale'), value: 'scale', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-shake'), value: 'shake', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-size'), value: 'size', selected: false, disabled: false},
            {name: vm.$t('ct-option-menu-mobile-effect-slide'), value: 'slide', selected: false, disabled: false}
          ],
          callback: function() {
            vm.resources.menuMobileEffect.defaultValue = this.value;
            vm.element.internal_config.menuMobileEffect = this.value;
          }
        },
        burguerMenuPosition: {
          name: 'burguerMenuPosition',
          defaultValue: 'right',
          labelDesc: 'burguer-menu-position',
          callback: function() {
            vm.resources.burguerMenuPosition.defaultValue = this.value;
            vm.element.internal_config.burguerMenu.position = this.value;
          }
        },
        burguerMenuIcon: {
          name: 'burguerMenuIcon',
          defaultValue: 'mdi-menu',
          labelDesc: 'burguer-menu-icon',
          showAlign: false,
          callback: function() {
            vm.resources.burguerMenuIcon.defaultValue = this.iconSelected;
            vm.element.internal_config.burguerMenu.icon = this.iconSelected;
          }
        },
        showBurguerMenuCloseIcon: {
          name: 'showBurguerMenuCloseIcon',
          defaultValue: true,
          labelDesc: 'show-burguer-menu-close-icon',
          callback: function() {
            vm.resources.showBurguerMenuCloseIcon.defaultValue = this.value;
            vm.element.internal_config.burguerMenu.showCloseIcon = this.value;
          }
        },
        burguerMenuColor: {
          name: 'burguerMenuColor',
          defaultValue: '#ffffff',
          labelDesc: 'burguer-menu-color',
          callback: function() {
            vm.resources.burguerMenuColor.defaultValue = this.colorValue;
            vm.element.internal_config.burguerMenu.color = this.colorValue;
          }
        },
        burguerMenuBackground: {
          name: 'burguerMenuBackground',
          defaultValue: '#000000',
          labelDesc: 'burguer-menu-background',
          callback: function() {
            vm.resources.burguerMenuBackground.defaultValue = this.colorValue;
            vm.element.internal_config.burguerMenu.backgroundColor = this.colorValue;
          }
        },
        brandImage: {
          name: 'brandImage',
          defaultValue: null,
          canRemove: true,
          showOptions: false,
          labelDesc: 'brand-image-menu',
          callback: function() {
            vm.resources.brandImage.defaultValue = this.value;
            vm.element.internal_config.brand.image = this.value;
          }
        },
        brandPosition: {
          name: 'brandPosition',
          defaultValue: 'left',
          labelDesc: 'brand-position-menu',
          callback: function() {
            vm.resources.brandPosition.defaultValue = this.value;
            vm.element.internal_config.brand.position = this.value;
          }
        },
        brandWidth: {
          name: 'brandWidth',
          defaultValue: '100',
          min: '10',
          max: '200',
          labelDesc: 'brand-width-menu',
          callback: function() {
            vm.resources.brandWidth.defaultValue = this.value;
            vm.element.internal_config.brand.width = this.value + 'px';
          }
        },
        vertical: {
          name: 'vertical',
          defaultValue: false,
          labelDesc: 'vertical-menu',
          callback: function() {
            vm.resources.vertical.defaultValue = this.value;
            vm.element.internal_config.vertical = this.value;
          }
        },
        fullWidth: {
          name: 'fullWidth',
          defaultValue: '',
          labelDesc: 'full-width',
          callback: function() {
            vm.resources.fullWidth.defaultValue = this.value;
            vm.element.internal_config.fullWidth = this.value;
          }
        },
        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';
          }
        },
        border: {
          name: 'border',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.border.defaultValue = value;
            vm.element.internal_config.border = value;
          }
        },
        borderRadius: {
          name: 'borderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'borderRadius',
          callback: function() {
            let value =
              this.v1 +
              'px ' +
              this.v2 +
              'px ' +
              this.v3 +
              'px ' +
              this.v4 +
              'px';

            vm.resources.borderRadius.defaultValue = value;
            vm.element.internal_config.borderRadius = value;
          }
        },
        boxShadow: {
          name: 'boxShadow',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'boxShadow',
          callback: function() {
            let value =
              this.h +
              'px ' +
              this.v +
              'px ' +
              this.b +
              'px ' +
              this.s +
              'px ' +
              this.colorValue +
              ' ' +
              (this.i === true ? 'inset' : '');

            vm.resources.boxShadow.defaultValue = value;
            vm.element.internal_config.boxShadow = value;
          }
        },
        backgroundColor: {
          name: 'backgroundColor',
          defaultValue: '#ffffff',
          labelDesc: 'bg-color',
          gradient: true,
          callback: function() {
            vm.resources.backgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.backgroundColor = this.colorValue;
          }
        },
        // height: {
        // 	name: 'height',
        // 	defaultValue: '300',
        // 	min: '50',
        // 	max: '1000',
        // 	labelDesc: 'height',
        // 	callback: function () {
        // 		vm.resources.height.defaultValue = this.value;
        // 		vm.element.internal_config.height = this.value + 'px';
        // 	},
        // },
        spacing: {
          name: 'spacing',
          defaultValue: '0',
          min: '0',
          max: '100',
          labelDesc: 'spacing',
          callback: function() {
            vm.resources.spacing.defaultValue = this.value;
            vm.element.internal_config.spacing = this.value + 'px';
          }
        },
        itemMenuHeight: {
          name: 'itemMenuHeight',
          defaultValue: '40',
          min: '30',
          max: '100',
          labelDesc: 'item-menu-height',
          callback: function() {
            vm.resources.itemMenuHeight.defaultValue = this.value;
            vm.element.internal_config.itemMenuHeight = this.value + 'px';
          }
        },
        itemMenuWidth: {
          name: 'itemMenuWidth',
          defaultValue: '100',
          min: '80',
          max: '500',
          labelDesc: 'item-menu-width',
          callback: function() {
            vm.resources.itemMenuWidth.defaultValue = this.value;
            vm.element.internal_config.itemMenuWidth = this.value + 'px';
          }
        },
        itemMenuBorder: {
          name: 'itemMenuBorder',
          defaultValue: '0px solid black',
          min: '0',
          max: '10',
          labelDesc: 'item-menu-border',
          callback: function() {
	          let value = this.value/2 + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.itemMenuBorder.defaultValue = value;
            vm.element.internal_config.itemMenuBorder = value;
          }
        },
        itemMenuBorderRadius: {
          name: 'itemMenuBorderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'item-menu-border-radius',
          callback: function() {
            let value =
              this.v1 +
              'px ' +
              this.v2 +
              'px ' +
              this.v3 +
              'px ' +
              this.v4 +
              'px';

            vm.resources.itemMenuBorderRadius.defaultValue = value;
            vm.element.internal_config.itemMenuBorderRadius = value;
          }
        },
        itemMenuBoxShadow: {
          name: 'itemMenuBoxShadow',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'item-menu-box-shadow',
          callback: function() {
            let value =
              this.h +
              'px ' +
              this.v +
              'px ' +
              this.b +
              'px ' +
              this.s +
              'px ' +
              this.colorValue +
              ' ' +
              (this.i === true ? 'inset' : '');

            vm.resources.itemMenuBoxShadow.defaultValue = value;
            vm.element.internal_config.itemMenuBoxShadow = value;
          }
        },

        itemMenuTextStyle: {
          name: 'itemMenuTextStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          labelDesc: 'itemMenuTextStyle',
          callback: function() {
            vm.resources.itemMenuTextStyle.defaultFamily = this.family;
            vm.element.internal_config.btnStyle.family = this.family;

            vm.resources.itemMenuTextStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.btnStyle.size = this.size + 'px';

            vm.resources.itemMenuTextStyle.defaultColor = this.color;
            vm.element.internal_config.btnStyle.color = this.color;

            vm.resources.itemMenuTextStyle.defaultAlign = this.align;
            vm.element.internal_config.btnStyle.align = this.align;

            vm.resources.itemMenuTextStyle.defaultWeight = this.weight;
            vm.element.internal_config.btnStyle.weight = this.weight;

            vm.resources.itemMenuTextStyle.defaultStyle = this.style;
            vm.element.internal_config.btnStyle.style = this.style;
          }
        },
        itemMenuSubTextStyle: {
          name: 'itemMenuSubTextStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          labelDesc: 'itemMenuSubTextStyle',
          callback: function() {
            vm.resources.itemMenuSubTextStyle.defaultFamily = this.family;
            vm.element.internal_config.subStyle.family = this.family;

            vm.resources.itemMenuSubTextStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.subStyle.size = this.size + 'px';

            vm.resources.itemMenuSubTextStyle.defaultColor = this.color;
            vm.element.internal_config.subStyle.color = this.color;

            vm.resources.itemMenuSubTextStyle.defaultAlign = this.align;
            vm.element.internal_config.subStyle.align = this.align;

            vm.resources.itemMenuSubTextStyle.defaultWeight = this.weight;
            vm.element.internal_config.subStyle.weight = this.weight;

            vm.resources.itemMenuSubTextStyle.defaultStyle = this.style;
            vm.element.internal_config.subStyle.style = this.style;
          }
        },
        btnStyleBackgroundColor: {
          name: 'btnStyleBackgroundColor',
          defaultValue: '#ffffff',
          labelDesc: 'bg-color',
          gradient: true,
          callback: function() {
            vm.resources.btnStyleBackgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.btnStyle.backgroundColor = this.colorValue;
          }
        },
        btnStyleBackgroundColorHover: {
          name: 'btnStyleBackgroundColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'bg-color-hover',
          callback: function() {
            vm.resources.btnStyleBackgroundColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.btnStyle.backgroundColorHover = this.colorValue;
          }
        },
        btnStyleTextColorHover: {
          name: 'btnStyleTextColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'text-color-hover',
          callback: function() {
            vm.resources.btnStyleTextColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.btnStyle.colorHover = this.colorValue;
          }
        },
        btnStyleBackgroundColorActive: {
          name: 'btnStyleBackgroundColorActive',
          defaultValue: '#ffffff',
          labelDesc: 'bg-color-active',
          callback: function() {
            vm.resources.btnStyleBackgroundColorActive.defaultValue = this.colorValue;
            vm.element.internal_config.btnStyle.backgroundColorActive = this.colorValue;
          }
        },
        btnSubStyleBackgroundColor: {
          name: 'btnSubStyleBackgroundColor',
          defaultValue: '#ffffff',
          labelDesc: 'sub-bg-color',
          gradient: true,
          callback: function() {
            vm.resources.btnSubStyleBackgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.subStyle.backgroundColor = this.colorValue;
          }
        },
        btnSubStyleBackgroundColorHover: {
          name: 'btnSubStyleBackgroundColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'sub-bg-color-hover',
          callback: function() {
            vm.resources.btnSubStyleBackgroundColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.subStyle.backgroundColorHover = this.colorValue;
          }
        },
        btnSubStyleTextColorHover: {
          name: 'btnSubStyleTextColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'sub-text-color-hover',
          callback: function() {
            vm.resources.btnSubStyleTextColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.subStyle.colorHover = this.colorValue;
          }
        },
        btnSubStyleBackgroundColorActive: {
          name: 'btnSubStyleBackgroundColorActive',
          defaultValue: '#ffffff',
          labelDesc: 'sub-bg-color-active',
          callback: function() {
            vm.resources.btnSubStyleBackgroundColorActive.defaultValue = this.colorValue;
            vm.element.internal_config.subStyle.backgroundColorActive = this.colorValue;
          }
        },
        itemMenuSubBorder: {
          name: 'itemMenuSubBorder',
          defaultValue: '0px solid black',
          min: '0',
          max: '10',
          labelDesc: 'item-menu-sub-border',
          callback: function() {
	          let value = this.value/2 + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.itemMenuSubBorder.defaultValue = value;
            vm.element.internal_config.itemMenuSubBorder = value;
          }
        },
      }
    };
  },
  methods: {
    setValuesData(data) {
      this.element = data;
      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

      this.resources.padding.defaultLeft = parseInt(
        data.internal_config.paddingLeft
      );
      this.resources.padding.defaultTop = parseInt(
        data.internal_config.paddingTop
      );
      this.resources.padding.defaultRight = parseInt(
        data.internal_config.paddingRight
      );
      this.resources.padding.defaultBottom = parseInt(
        data.internal_config.paddingBottom
      );

      this.resources.vertical.defaultValue = data.internal_config.vertical;
      this.resources.fullWidth.defaultValue = data.internal_config.fullWidth;
      this.resources.alignMenu.defaultValue = data.internal_config.align;

      this.resources.menuMobileEffect.defaultValue =
        data.internal_config.menuMobileEffect;

      this.resources.burguerMenuPosition.defaultValue =
        data.internal_config.burguerMenu.position;

      this.resources.burguerMenuIcon.defaultValue =
        data.internal_config.burguerMenu.icon;

      this.resources.showBurguerMenuCloseIcon.defaultValue =
        data.internal_config.burguerMenu.showCloseIcon;

      this.resources.burguerMenuColor.defaultValue =
        data.internal_config.burguerMenu.color;

      this.resources.burguerMenuBackground.defaultValue =
        data.internal_config.burguerMenu.backgroundColor;

      this.resources.brandImage.defaultValue =
        data.internal_config.brand.image;

      this.resources.brandPosition.defaultValue =
        data.internal_config.brand.position;

      this.resources.brandWidth.defaultValue =
        data.internal_config.brand.width;

      this.resources.border.defaultValue = data.internal_config.border;
      this.resources.borderRadius.defaultValue =
        data.internal_config.borderRadius;
      this.resources.boxShadow.defaultValue = data.internal_config.boxShadow;

      this.resources.backgroundColor.defaultValue =
        data.internal_config.backgroundColor;

      this.resources.spacing.defaultValue = parseInt(
        data.internal_config.spacing
      );

      this.resources.itemMenuBorder.defaultValue = data.internal_config.itemMenuBorder;
      this.resources.itemMenuBorderRadius.defaultValue = data.internal_config.itemMenuBorderRadius;
      this.resources.itemMenuWidth.defaultValue = data.internal_config.itemMenuWidth;
      this.resources.itemMenuHeight.defaultValue = data.internal_config.itemMenuHeight;

      this.resources.itemMenuBoxShadow.defaultValue = data.internal_config.itemMenuBoxShadow;

      this.resources.itemMenuTextStyle.defaultFamily =
        data.internal_config.btnStyle.family;
      this.resources.itemMenuTextStyle.defaultSize =
        data.internal_config.btnStyle.size;
      this.resources.itemMenuTextStyle.defaultColor =
        data.internal_config.btnStyle.color;
      this.resources.itemMenuTextStyle.defaultAlign =
        data.internal_config.btnStyle.align;
      this.resources.itemMenuTextStyle.defaultWeight =
        data.internal_config.btnStyle.weight;
      this.resources.itemMenuTextStyle.defaultStyle =
        data.internal_config.btnStyle.style;

      this.resources.itemMenuSubTextStyle.defaultFamily =
        data.internal_config.subStyle.family;
      this.resources.itemMenuSubTextStyle.defaultSize =
        data.internal_config.subStyle.size;
      this.resources.itemMenuSubTextStyle.defaultColor =
        data.internal_config.subStyle.color;
      this.resources.itemMenuSubTextStyle.defaultAlign =
        data.internal_config.subStyle.align;
      this.resources.itemMenuSubTextStyle.defaultWeight =
        data.internal_config.subStyle.weight;
      this.resources.itemMenuSubTextStyle.defaultStyle =
        data.internal_config.subStyle.style;

      this.resources.btnStyleBackgroundColor.defaultValue =
        data.internal_config.btnStyle.backgroundColor;
      this.resources.btnStyleBackgroundColorHover.defaultValue =
        data.internal_config.btnStyle.backgroundColorHover;
      this.resources.btnStyleBackgroundColorActive.defaultValue =
        data.internal_config.btnStyle.backgroundColorActive;

      if(!data.internal_config.btnStyle.colorHover) {
        data.internal_config.btnStyle.colorHover =  data.internal_config.btnStyle.color;
      }

      this.resources.btnStyleTextColorHover.defaultValue =
        data.internal_config.btnStyle.colorHover;

      this.resources.btnSubStyleBackgroundColor.defaultValue =
        data.internal_config.subStyle.backgroundColor;
      this.resources.btnSubStyleBackgroundColorHover.defaultValue =
        data.internal_config.subStyle.backgroundColorHover;
      this.resources.btnSubStyleBackgroundColorActive.defaultValue =
        data.internal_config.subStyle.backgroundColorActive;

      if(!data.internal_config.subStyle.colorHover) {
        data.internal_config.subStyle.colorHover =  data.internal_config.subStyle.color;
      }

      this.resources.btnSubStyleTextColorHover.defaultValue =
        data.internal_config.subStyle.colorHover;
    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Menu/Resources.vue